const useToCommisions = () => {
  const calculateDebts = (taxDistance) => {
    var ret_Isr = 0.021; //Cantidad de ISR
    var ret_Iva = 0.08; //Cantidad de IVA
    var nullIVA = taxDistance / 1.16; // Suma de Tarfifas(Collection + Delivery + Distance) - IVA 16%
    var null_Isr = nullIVA * ret_Isr; //Retención ISR
    var null_Iva = nullIVA * ret_Iva; //Retención IVA
    var res = null_Isr + null_Iva; //Suma de (retención ISR + retención IVA)
    return res;
  };

  return { calculateDebts };
};

export default useToCommisions;
